import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/opt/buildhome/repo/components/ui/LanguageToggle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/opt/buildhome/repo/components/ui/ThemeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
